var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"disabled":!_vm.truncate,"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var tooltip = ref.on;
return [_c('span',_vm._g({staticClass:"d-inline-block text-truncate",style:('max-width: '+_vm.width+'px;'),on:{"dblclick":_vm.dbclick}},Object.assign({}, tooltip)),[_vm._v(" "+_vm._s(_vm.value)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }